import React, { FC, useEffect } from 'react';
import { Loader } from '../../../common/components/Loader';

import s from './WidgetContainer.scss';
import { createFedopsLogger } from '../../../util/fedops';

type WidgetContainerProps = {
  dataHook: string;
};

const fedopsLogger = createFedopsLogger(false);

export const WidgetContainer: FC<WidgetContainerProps> = ({ dataHook }) => {
  useEffect(() => {
    const loadWidget = async () => {
      window.WixSupportChatSDK.on('appRenderComplete', () => {
        fedopsLogger.appLoaded();
      });

      await window.WixSupportChatSDK.init({
        ...window.chatbotSdkInitParams,
        enableHelpCenterWidget: true,
        placeholder: {
          element: '#widgetContainer',
        },
      });
    };

    loadWidget();
  });

  return (
    <div className={s.root} id="widgetContainer" data-hook={dataHook}>
      <Loader
        height="100%"
        width="100%"
        position="absolute"
        verticalAlign="middle"
      />
    </div>
  );
};

export default WidgetContainer;
